import { useGtm } from '@gtm-support/vue-gtm';

export const useClockBookingEngine = () => {
	const { locale } = useI18n();
	const gtm = useGtm();

	onMounted(() => {
		if (!window.clockPmsWbeInit) {
			return;
		}

		window.clockPmsWbeInit({
			wbeBaseUrl: 'https://sky-eu1.clock-software.com/spa/pms-wbe/#/hotel/11152',
			defaultMode: 'fullscreen',
			roundedCorners: false,
			language: locale.value,
		});

		window.clockPmsWbePageViewCallback = function (params: {
			pageName: string;
			totalPriceCents: number;
			totalPriceCurrency: string;
			bookingNumbers?: string[];
			roomTypeName?: string;
			hotelId?: string;
			hotelName?: string;
			roomCount?: number;
			arrival?: string;
			departure?: string;
			googleMeasurementId?: string;
			stay?: number;
			today?: string;
			leadDays?: number;
			rateName?: string;
			offerNumber?: number;
		}) {
			if (!gtm) {
				return;
			}

			// Recommended in the docs to prevent multiple ecommerce events on a page from affecting each other
			gtm.push({ ecommerce: null });

			gtm.push({
				event: 'clockPMSPageView',
				hotel_id: params.hotelId || null,
				hotel_name: params.hotelName || null,
				ga_measurement_id: params.googleMeasurementId || null,
				page_name: params.pageName || null,
				arrival: params.arrival || null,
				departure: params.departure || null,
				stay: params.stay || null,
				today: params.today || null,
				lead_days: params.leadDays || null,
				room_type_name: params.roomTypeName || null,
				rate_name: params.rateName || null,
				room_count: params.roomCount || null,
				total_price: params.totalPriceCents ? params.totalPriceCents / 100 : null,
				currency: params.totalPriceCurrency || null,
				booking_numbers: params.bookingNumbers ? params.bookingNumbers.join(',') : null,
				offer_number: params.offerNumber || null,
			});

			if (params.roomTypeName) {
				localStorage.setItem('lastRoomType', params.roomTypeName);
			}
			const roomName = params.roomTypeName || localStorage.getItem('lastRoomType') || 'Room';

			const item = {
				item_name: roomName,
				item_id: params.hotelId || 'Unknown Hotel',
				price: params.totalPriceCents ? params.totalPriceCents / 100 : 0,
				quantity: params.roomCount || 1,
				item_category: 'Rooms',
			};

			// Ecommerce events
			switch (params.pageName) {
				case 'rooms':
					gtm.push({
						event: 'view_item_list',
						ecommerce: {
							item_list_name: 'Available Rooms',
							items: [item],
						},
					});
					break;

				case 'rates':
					gtm.push({
						event: 'view_item',
						ecommerce: {
							items: [item],
						},
					});
					break;

				case 'extras':
					gtm.push({
						event: 'add_to_cart',
						ecommerce: {
							items: [item],
						},
					});
					break;

				case 'checkout':
					gtm.push({
						event: 'begin_checkout',
						ecommerce: {
							items: [item],
						},
					});
					break;

				case 'completed':
					gtm.push({
						event: 'purchase',
						ecommerce: {
							transaction_id: params.bookingNumbers ? params.bookingNumbers.join(',') : 'unknown',
							affiliation: params.hotelName || 'Hotel Booking',
							value: params.totalPriceCents ? params.totalPriceCents / 100 : 0,
							currency: params.totalPriceCurrency,
							tax: 0,
							shipping: 0,
							items: [
								{
									...item,
									start_date: params.arrival,
									end_date: params.departure,
								},
							],
						},
					});
					break;
			}
		};
	});
};
